export default [
  "Chris Daemmrich",
  "Chris Reed",
  "Cole	Townsend",
  "Danielle Choi",
  "Ekene Ijeoma",
  "Elizabeth Trost",
  "Emma	Ogiemwanye",
  "Little Wing Lee",
  "Natasha Rodriguez-Bacchus",
  "Shay	Bennett",
]
